import * as React from 'react'
import { SettingsIcon } from '@/app/features/icons/Settings'
import { HeadBar } from './components/HeadBar'
import { DatePickerRangeProps } from '../drivers/types'
import { useTimetable } from './stores/timetableStore'
import TimetabelViewControlBarSelected from './shared/viewBars/TimetabelViewControlBarSelected'
import clx from 'classnames'
import { useLocalize } from '../shared/context/localize/LocalizeContext'

type Props = {
  children: React.ReactNode
  companyId: string
  viewControlBar?: () => React.JSX.Element
  heightScreen?: boolean
  fullScreen?: boolean
}

export const TimetableLayout = ({
  children,
  viewControlBar: ViewControlBar,
  companyId,
  heightScreen = false,
  fullScreen = false,
}: Props) => {
  const { dateRange, setDateRange, selectedAlerts, setSelectedAlerts } =
    useTimetable()
    const {t} = useLocalize()
  const handleDateRangeChange = React.useCallback(
    (newRange: DatePickerRangeProps) => {
      setDateRange(newRange)
    },
    [setDateRange],
  )
  const isAnySelected = selectedAlerts?.length > 0

  const handleResetAll = React.useCallback(() => {
    setSelectedAlerts([])
  }, [setSelectedAlerts])
  const baseClasses = clx(
    'module-timetable tw-flex tw-flex-[1] tw-flex-col tw-overflow-hidden tw-text-content-base tw-bg-base-100 tw-min-w-[900px] tw-max-w-full',
    {
      'tw-h-screen': fullScreen,
      'tw-padding-4 tw-mt-1 tw-mb-1 tw-rounded-xl tw-border tw-border-base-300':
        !fullScreen,
      'tw-max-h-[calc(100vh-8px)]': !fullScreen && heightScreen,
      'tw-min-h-[calc(100vh-8px)]': !fullScreen && !heightScreen,
    },
  )
  const boundaryRef = React.useRef<HTMLDivElement>(null)
  return (
    <div className={baseClasses} ref={boundaryRef}>
      <HeadBar
        title={t('dashboard.calendar')}
        icon={<SettingsIcon />}
        handleDateRangeChange={handleDateRangeChange}
        range={dateRange}
      />
      {isAnySelected ? (
        <TimetabelViewControlBarSelected
          resetAll={handleResetAll}
          companyId={companyId}
        />
      ) : (
        ViewControlBar && <ViewControlBar />
      )}
      <main
        className={`tw-flex tw-w-full tw-flex-1 ${heightScreen ? 'tw-max-h-screen tw-flex-col tw-overflow-hidden' : ''} `}
      >
        {children}
      </main>
    </div>
  )
}
